import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class NomineeDetailsUseCase extends BaseUseCase {
    constructor(nomineeDetailsRep) {
        super();
        this.nomineeDetailsRep = nomineeDetailsRep;
    }
    async fetchResult(req) {
        return await this.nomineeDetailsRep.nomineeDetailsData(req);
    }
}
export default NomineeDetailsUseCase;
